/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StepErrorDto
 */
export interface StepErrorDto {
    /**
     * 
     * @type {string}
     * @memberof StepErrorDto
     */
    level: StepErrorDtoLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof StepErrorDto
     */
    message: string;
    /**
     * 
     * @type {object}
     * @memberof StepErrorDto
     */
    details?: object;
}


/**
 * @export
 */
export const StepErrorDtoLevelEnum = {
    Error: 'error',
    Warning: 'warning',
    Info: 'info',
    RequestInfo: 'requestInfo',
    RequestError: 'requestError',
    Future: 'future',
    NotApplicable: 'notApplicable'
} as const;
export type StepErrorDtoLevelEnum = typeof StepErrorDtoLevelEnum[keyof typeof StepErrorDtoLevelEnum];


/**
 * Check if a given object implements the StepErrorDto interface.
 */
export function instanceOfStepErrorDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "level" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function StepErrorDtoFromJSON(json: any): StepErrorDto {
    return StepErrorDtoFromJSONTyped(json, false);
}

export function StepErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepErrorDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'level': json['level'],
        'message': json['message'],
        'details': !exists(json, 'details') ? undefined : json['details'],
    };
}

export function StepErrorDtoToJSON(value?: StepErrorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'level': value.level,
        'message': value.message,
        'details': value.details,
    };
}

